<script setup lang="ts">
import { ref, watch, nextTick } from 'vue';
import BasicModal from '@/components/display/general/BasicModal.vue';
import UIkit from 'uikit';

interface Props {
  open?: boolean;
  emptyAnnotation?: boolean;
}

interface Emits {
  (e: 'close'): void;
}

const props = withDefaults(defineProps<Props>(), {
  open: false,
  emptyAnnotation: true,
});

const emit = defineEmits<Emits>();

const emptyAnnotationModal = ref<HTMLElement>();

watch(
  () => props.open,
  newVal => {
    if (newVal) {
      nextTick(() => {
        if (emptyAnnotationModal.value) {
          UIkit.modal(emptyAnnotationModal.value).show();
        }
      });
    }
  }
);

const hide = () => {
  if (emptyAnnotationModal.value) {
    UIkit.modal(emptyAnnotationModal.value).hide();
  }
  emit('close');
};
</script>

<template>
  <div v-if="open" uk-modal ref="emptyAnnotationModal" id="emptyAnnotationModal">
    <BasicModal>
      <div uk-alert class="uk-alert-warning uk-flex" style="align-items: baseline">
        <i uk-icon="warning" style="min-width: 1rem"></i>
        <span v-if="emptyAnnotation" class="uk-margin-small-left uk-text-secondary">
          Blank annotations are not allowed. Please add content to your annotation or delete it.
        </span>
        <span v-else class="uk-margin-small-left uk-text-secondary">
          Please wait until all annotations have been updated.
        </span>
      </div>

      <div class="uk-text-center uk-flex uk-flex-right">
        <button
          class="uk-button uk-button-default uk-button-primary uk-margin-top uk-border-rounded"
          @click="hide"
        >
          OK
        </button>
      </div>
    </BasicModal>
  </div>
</template>
